<template>
    <div>
        <v-alert outline style="text-align: left;width: 50%" class="mb-3"
                  :value="alert.visible"
                  :type="alert.type" >
            {{alert.text}}
        </v-alert>
    </div>
</template>

<script>
    import AuthRepository from "@/repositories/AuthRepository";

    import { VToolbar, VLayout, VToolbarTitle, VBtn, VIcon, VForm, VTextField, VContainer, VAlert } from 'vuetify/lib'

    export default {
        name: "VerifyAccount",
        components: {
            VToolbar, VLayout, VToolbarTitle, VBtn, VIcon, VForm, VTextField, VContainer, VAlert
        },
        data () {
            return {
                // Alert
                alert: {},
                token: ''
            }
        },
        methods: {
            verify() {
                if (this.$route.params.token) {
                    this.token = this.$route.params.token;
                    AuthRepository.verify(this.token)
                        .then((response) => {
                            if (response.data.error) {
                                this.alertSuccess(response.data.message + " You can now log in!");
                            } else {
                                this.alertError(response.data.message);
                            }
                        }).catch((error) =>{
                            this.alertError(error.data.message);
                        });
                }
            },
            alertSuccess(text) {
                this.alert = {
                    type: "success",
                    text: text,
                    visible: true
                }
            },
            alertError(text) {
                this.alert = {
                    type: "error",
                    text: text,
                    visible: true
                }
            }
        },
        beforeMount(){
            if (this.$route.params.token) {
                this.token = this.$route.params.token;
                AuthRepository.verify(this.token)
                    .then((response) => {
                        if (response.data.error) {
                            this.alertSuccess(response.data.message + " You can now log in!");
                        } else {
                            this.alertError(response.data.message);
                        }
                    }).catch((error) =>{
                    this.alertError(error.data.message);
                });
            }
        }
    }
</script>

<style scoped>

</style>